import { slices } from "@/constants/sliceNames";
import {
  AnalyticsDefectsInfo,
  AnalyticsGeneralInfo,
  AnalyticsJudgementInfo,
  JudgementPointsInfo,
  PlatesImagesInfo,
} from "@/entities/BatchPredictionMonitor/BatchPredictionMonitorAnalytics";
import { createSlice } from "@reduxjs/toolkit";

// eslint-disable-next-line no-unused-vars
import { BatchPredictionMonitor } from "../../entities/BatchPredictionMonitor/BatchPredictionMonitor";
import { BatchPredictionMonitorData } from "../../entities/BatchPredictionMonitor/BatchPredictionMonitorData";
import {
  requestBatchPredictionMonitorsStatus,
  requestSingleBatchPredictionMonitorStatus,
  requestBatchPredictionMonitorDataStatus,
  requestFeedbackProjectsStatus,
  requestCreateFeedbackProjectStatus,
  requestPushImageFeedbackStatus,
  requestMonitorAnalyticsGeneralInfoStatus,
  requestMonitorAnalyticsJudgmentsPerSideStatus,
  requestMonitorAnalyticsDefectsPerSideStatus,
  requestDefectsLocationsPerSideStatus,
  requestPlateImagesAnalyticsStatus,
} from "../effects/batch-prediction/batchPredictionMonitoring-effects";

const initialState = {
  /**@type {BatchPredictionMonitor[]} */
  monitors: [],

  /**@type {number} */
  recordsCount: 0,

  /**@type {boolean} */
  loading: false,

  /**@type {BatchPredictionMonitor} */
  item: {},

  /**@type {boolean} */
  dataLoading: false,

  /**@type {BatchPredictionMonitorData} */
  itemData: new BatchPredictionMonitorData(),

  /**@type {number} */
  totalItemData: 1,

  /** @type {Object} */
  feedback: {},

  /** @type {AnalyticsGeneralInfo} */
  generalInfo: new AnalyticsGeneralInfo(),

  /** @type {AnalyticsJudgementInfo} */
  judgementInfo: new AnalyticsJudgementInfo(),

  /** @type {AnalyticsDefectsInfo} */
  defectsInfo: new AnalyticsDefectsInfo(),

  /** @type {PlatesImagesInfo} */
  plateImagesInfo: new PlatesImagesInfo(),

  /** @type {JudgementPointsInfo} */
  judgementPointsInfo: new JudgementPointsInfo(),
  /** @type {string}*/
  analysisError: "",
};

const batchPredictionMonitoringSlice = createSlice({
  name: slices.batchPredictionMonitoring,
  initialState,
  reducers: {
    resetAnalysis: (state, action) => {
      state.analysisError = "";
    },
  },
  extraReducers: {
    ...requestBatchPredictionMonitorsStatus,
    ...requestSingleBatchPredictionMonitorStatus,
    ...requestBatchPredictionMonitorDataStatus,
    ...requestFeedbackProjectsStatus,
    ...requestCreateFeedbackProjectStatus,
    ...requestPushImageFeedbackStatus,
    ...requestMonitorAnalyticsGeneralInfoStatus,
    ...requestMonitorAnalyticsJudgmentsPerSideStatus,
    ...requestMonitorAnalyticsDefectsPerSideStatus,
    ...requestDefectsLocationsPerSideStatus,
    ...requestPlateImagesAnalyticsStatus,
  },
});

const { actions, reducer } = batchPredictionMonitoringSlice;

const { resetAnalysis } = actions;

export { actions, initialState, resetAnalysis };

export default reducer;
